/**
 * Svg Gradient Color Type.
 */ const SvgIconsGradient = {
    AdjustmentsOutline: 'stroke',
    ArchiveOutline: 'stroke',
    ArrowCircleUpOutline: 'stroke',
    ArrowDownSolid: 'fill',
    ArrowsExpandDiagonalOutline: 'stroke',
    ArrowsExpandOutline: 'stroke',
    ArrowLeftOutline: 'stroke',
    ArrowLeftSolid: 'fill',
    ArrowRightOutline: 'stroke',
    ArrowRightSolid: 'fill',
    ArrowSmBottomLeftSolid: 'stroke',
    ArrowSmDownOutline: 'stroke',
    ArrowSmTopRightSolid: 'stroke',
    ArrowSmUpSolid: 'fill',
    ArrowNarrowLeftSolid: 'fill',
    ArrowNarrowRightSolid: 'fill',
    ArrowUpSolid: 'fill',
    BadgeCheckOutline: 'stroke',
    BeakerOutline: 'stroke',
    BellOutline: 'stroke',
    BookOpenOutline: 'stroke',
    BroadcastSolid: 'fill',
    BullhornOutline: 'stroke',
    CalendarOutline: 'stroke',
    CardSolid: 'fill',
    ChartBarOutline: 'stroke',
    ChartBarSolid: 'fill',
    ChartTrendingUpOutline: 'stroke',
    ChatOutline: 'stroke',
    CheckOutline: 'fill',
    CheckboxCheckSolid: 'fill',
    CheckboxIndeterminateSolid: 'fill',
    CheckCircleOutline: 'stroke',
    CheckCircleSolid: 'fill',
    ChevronLeftOutline: 'stroke',
    ChevronDownOutline: 'stroke',
    ChevronRightOutline: 'stroke',
    ChevronUpOutline: 'stroke',
    ChevronLeftSolid: 'fill',
    ChevronDownSolid: 'fill',
    ChevronRightSolid: 'fill',
    ChevronUpSolid: 'fill',
    CircleSpinnerSolid: 'fill',
    ClipboardCheckOutline: 'stroke',
    ClipboardListOutline: 'stroke',
    ClipboardListSolid: 'fill',
    ClockNavOutline: 'stroke',
    ClockOutline: 'stroke',
    ClockSolid: 'fill',
    CloudSolid: 'fill',
    CodeOutline: 'stroke',
    CogOutline: 'stroke',
    CogSolid: 'fill',
    CoinOutline: 'stroke',
    CollectionOutline: 'stroke',
    ComputerOutline: 'stroke',
    ContractOutline: 'stroke',
    CreditCardOutline: 'stroke',
    CubeTransparentOutline: 'stroke',
    CurrencyDollarOutline: 'stroke',
    CurrencyEuroOutline: 'stroke',
    CurrencyExchangeSolid: 'fill',
    CustodyOutline: 'stroke',
    DeviceMobileOutline: 'stroke',
    DocumentSearchOutline: 'stroke',
    DeviceMobileSolid: 'fill',
    DocumentTextOutline: 'stroke',
    DocumentsOutline: 'stroke',
    DotsHorizontalSolid: 'fill',
    DotsVerticalSolid: 'fill',
    DownloadSolid: 'fill',
    DuplicateOutline: 'stroke',
    DuplicateSolid: 'fill',
    EllipseOutline: 'fill',
    EllipseSolid: 'fill',
    ExclamationCircleOutline: 'stroke',
    ExclamationCircleSolid: 'fill',
    ExclamationOutline: 'stroke',
    ExclamationSolid: 'fill',
    ExchangeSolid: 'fill',
    ExternalLinkOutline: 'stroke',
    EyeOffSolid: 'fill',
    EyeSolid: 'fill',
    FaucetSolid: 'fill',
    FeeOutline: 'fill',
    FileSolid: 'fill',
    FilterSolid: 'fill',
    FingerprintOutline: 'stroke',
    FingerprintSolid: 'fill',
    FlagOutline: 'stroke',
    FlagSolid: 'fill',
    FolderOpenSolid: 'fill',
    FolderSolid: 'fill',
    GamingOutline: 'stroke',
    GasPumpOutline: 'stroke',
    GasPumpSolid: 'fill',
    GiftOutline: 'stroke',
    GiftSolid: 'fill',
    GlobeAltOutline: 'stroke',
    GlobeOutline: 'stroke',
    GovernmentOutline: 'stroke',
    GraphIncreaseOutline: 'stroke',
    HashtagOutline: 'stroke',
    HomeOutline: 'stroke',
    IndeterminateSolid: 'fill',
    InformationCircleOutline: 'stroke',
    InformationCircleSolid: 'fill',
    KeyOutline: 'stroke',
    KeySolid: 'fill',
    LaunchOutline: 'stroke',
    LibraryOutline: 'stroke',
    LibrarySolid: 'fill',
    LightningBoltOutline: 'stroke',
    LightningBoltSolid: 'fill',
    LightBulbOutline: 'stroke',
    LinkOutline: 'stroke',
    LocationMarkerOutline: 'stroke',
    LockClosedOutline: 'stroke',
    LockClosedSolid: 'fill',
    LockOpenSolid: 'fill',
    LoginSolid: 'fill',
    LogoutOutline: 'stroke',
    MenuAlt2Outline: 'stroke',
    MailOutline: 'stroke',
    MailSolid: 'fill',
    MinusSolid: 'fill',
    MoonOutline: 'stroke',
    MoveSolid: 'fill',
    MultiTokenOutline: 'stroke',
    NFTOutline: 'stroke',
    Number1Solid: 'fill',
    Number2Solid: 'fill',
    Number3Solid: 'fill',
    OfficeBuildingOutline: 'stroke',
    OfficeBuildingSolid: 'fill',
    PaperAirPlaneSolid: 'fill',
    PaperAirplaneLeftOutline: 'stroke',
    PaperAirplaneRightOutline: 'stroke',
    PencilOutline: 'stroke',
    PencilSolid: 'fill',
    PlayOutline: 'stroke',
    PlusCircleOutline: 'stroke',
    PlusSolid: 'stroke',
    PresentationChartLineOutline: 'fill',
    PuzzleOutline: 'stroke',
    QRCodeSolid: 'fill',
    QuestionMarkCircleOutline: 'stroke',
    QuestionMarkCircleSolid: 'fill',
    ReceiptInvoiceOutline: 'stroke',
    RefreshOutline: 'stroke',
    RSSOutline: 'stroke',
    SearchCircleOutline: 'stroke',
    SearchOutline: 'stroke',
    ServerOutline: 'stroke',
    ShareOutline: 'stroke',
    ShieldCheckOutline: 'stroke',
    ShieldCheckSolid: 'fill',
    ShieldExclamationOutline: 'stroke',
    ShoppingCartOutline: 'stroke',
    SnowflakeOutline: 'stroke',
    SparklesOutline: 'stroke',
    SpeakerphoneSolid: 'fill',
    StarOutline: 'stroke',
    SubtitlesSolid: 'fill',
    SuccessOutline: 'stroke',
    SunOutline: 'stroke',
    SupportSolid: 'fill',
    SwitchHorizontalOutline: 'stroke',
    SwitchVerticalOutline: 'stroke',
    SwitchVerticalSolid: 'fill',
    TagOutline: 'fill',
    TemplateOutline: 'stroke',
    TemplateSolid: 'fill',
    TerminalOutline: 'stroke',
    TerminalSolid: 'fill',
    ThumbsDownOutline: 'stroke',
    ThumbsUpOutline: 'stroke',
    TokenSolid: 'fill',
    TransactionOutline: 'stroke',
    TrashOutline: 'stroke',
    TrashSolid: 'fill',
    TrendingDownOutline: 'stroke',
    TrendingUpOutline: 'stroke',
    TrendingUpSolid: 'fill',
    UndoOutline: 'stroke',
    USDCOutline: 'stroke',
    UserSolid: 'fill',
    UserGroupOutline: 'stroke',
    UserOutline: 'stroke',
    UsersOutline: 'stroke',
    UserCircleOutline: 'stroke',
    ViewGridOutline: 'stroke',
    VariableOutline: 'stroke',
    VaultSolid: 'fill',
    WalletOutline: 'stroke',
    WalletSolid: 'fill',
    WithdrawalSolid: 'fill',
    XCircleOutline: 'stroke',
    XCircleSolid: 'fill',
    XSolid: 'fill'
};

export { SvgIconsGradient };
//# sourceMappingURL=Icon.Gradient.Icons.es.js.map
